module.exports = ".content{\r\n    overflow: auto;\r\n    height: 400px;\r\n}"